export default __webpack_public_path__ + "images/defaultAvatar.ea5277efc1666355b3456ab3a7c11327.jpg";